<template>
  <header class="top-navbar logo-style">
    <div class="log-wrapper">
      <div class="small-logo">
        <router-link to="/" class="navbar-brand" ><img src="../../assets/icons/petit-logo.svg" alt="logo" /></router-link>
        
      </div>
      <div class="big-logo">
        <router-link to="/" class="navbar-brand" ><img src="../../assets/icons/logo-ecole.svg" alt="logo" /></router-link>
        
      </div>
    </div>
  </header>
</template>



<script>
export default {
  name: "HeadeSidebar"
};
</script>
